import styled from 'styled-components'

export const InfoContainer = styled.section`
color: #fff;
background: ${({lightBg}) => (lightBg ? '#00': '#1fa8ff')};

@media only screen and (max-width:768px){
  padding: 100px 0;
}
`;


export const InfoWrapper = styled.div`
display: grid;
z-index: 1;
height: 100vh;
// height: 60rem;
width: 100%;
max-width: 1400px;
margin: 0 auto;
padding: 0 24px;
justify-content: center;
@media only screen and (max-width:768px){
  height: 950px;
}
`;

export const InfoRow = styled.div`
display: grid;
grid-auto-columns: minmax(auto, 1fr);
align-items: center;
grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};

@media only screen and (max-width: 768px){
  grid-template-areas: ${({imgStart}) => (imgStart ? `'col1 col1' 'col2 col2'` : `'col1 col1' 'col2 col2'`)};
}

`;
export const Column1 = styled.div`
margin-bottom: 15px;
padding: 0 15px;
grid-area: col1;
`;

export const Column2 = styled.div`
margin-bottom: 15px;
padding: 0 15px;
grid-area: col2;
`;
export const TextWrapper = styled.div`
max-width: 700px;
padding-top: 0;
padding-bottom: 60px;
`;

export const Heading = styled.h2`
color: #010606;
font-weight: 800;
letter-spacing: 1.4px;
text-transform: uppercase;
margin-bottom: 16px;
`;
export const TopLine = styled.h3`
margin-bottom: 24px;
font-size: 3.2rem;
line-height: 1.1;
font-weight: 700;
color: ${({lightText}) => (lightText ? '#f7f8fa' : '#010606')};
@media only screen and (max-width: 1200px){
  font-size: 3rem;
}
@media only screen and (max-width: 480px){
  font-size: 3.2rem;
}
`;
export const SubTitle = styled.h4`
max-width: 600px;
margin-bottom: 35px;
font-size: 1.8rem;
/* line-height: 1.6; */
color: ${({darkText}) => (darkText ? '#010606' : '#fff')};
`;

export const SubText = styled.h4`
max-width: 600px;
font-size: 1.8rem;
/* line-height: 1.6; */
color: #000 ;
padding-bottom: 1rem;
@media only screen and (max-width:280px){
  font-size: 1.5rem;
}
`;

export const SubTextt = styled.h4`
max-width: 600px;
padding-top: 2rem;
font-size: 1.8rem;
font-weight: 700;
/* line-height: 1.6; */
color: #000 ;
`;

export const ImgWrapper = styled.div`
max-width: 600px;
height: 100%;
@media only screen and (max-width: 768px){
  @media only screen and (min-width: 500px){
  height: 75%;
  width: 75%;
}}
`;

export const Img = styled.img`
width: 100%;
margin: 0 0 10px 0;
padding-right: 0;
`;